"use client";
import Link from "next/link";
import { trackTmjEvent } from "./analytics";
export default function BookingLink({children="Online időpontfoglalás"}:{children?:React.ReactNode}) {
  return <Link href="/gyogytorna-foglalas" onClick={()=>trackTmjEvent("tmj_booking_cta")} className="inline-flex items-center justify-center rounded-full bg-hill-primary px-7 py-4 font-semibold text-white shadow-sm transition hover:bg-hill-primary/90">{children}</Link>;
}
